import { IPublicClientApplication } from '@azure/msal-browser';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import { scanRubricPii } from './index';

export const createRubricPiiScanApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  scanRubricPii: (instance: IPublicClientApplication, text: string) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => scanRubricPii(fetchContext, text, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('scanRubricPii', isInFlight);
    },
  ),
});
